import React, { CSSProperties, useState } from 'react';

import bannerImage from 'assets/banner-bck.png';
import closeIcon from 'assets/icons/x.svg';
import './Banner.scoped.scss';

interface Props {
  style?: CSSProperties;
  title?: string;
  content?: string;
}

const Banner: React.FC<Props> = ({ title, content }) => {
  const [isVisible, setVisible] = useState(true);
  return (
    <div
      className="banner-container"
      style={{
        backgroundImage: `url(${bannerImage})`,
        display: `${isVisible ? 'block' : 'none'}`,
      }}
    >
      <div className="banner-content">
        <h2>{title}</h2>
        <p>{content}</p>
      </div>
      <div className="close-button pointer" onClick={() => setVisible(false)}>
        <img src={closeIcon} alt="close-icon" />
      </div>
    </div>
  );
};

export default Banner;
